/**
 * «Në cilën kompani?» — kur i njëjti email ka llogari në më shumë se një kompani.
 *
 * Serveri e thotë këtë me `{ success: true, needsCompany: true, data: { companies } }`
 * dhe pret që kërkesa të përsëritet me `tenant`. Faqet e hyrjes nuk e njihnin këtë
 * përgjigje: s'kishte `user`, ndaj shfaqnin «Email ose fjalëkalim i gabuar» — edhe
 * me fjalëkalimin e saktë (2026-10-01, një llogari te Nexuma dhe një te FAR Logistics).
 *
 * Secila kompani ka fjalëkalimin e vet: kjo dritare vetëm zgjedh ku të provohet
 * ai që u shkrua.
 */
import React from 'react';
import {
  Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Stack, Typography,
} from '@mui/material';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

export default function CompanyPickerDialog({ open, companies = [], busySlug = null, onPick, onClose }) {
  return (
    <Dialog open={open} onClose={busySlug ? undefined : onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 0.5 }}>
        <Typography component="div" sx={{ fontWeight: 700, fontSize: 19, color: '#0F172A' }}>Zgjidhni kompaninë</Typography>
        <Typography component="div" sx={{ fontSize: 13.5, color: '#475569', mt: 0.5, lineHeight: 1.5 }}>
          Ky email ka llogari në më shumë se një kompani. Secila ka fjalëkalimin e vet.
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 2.5 }}>
        <Stack spacing={1} sx={{ mt: 1.5 }}>
          {companies.map((co) => (
            <Button
              key={co.slug}
              onClick={() => onPick(co.slug)}
              disabled={Boolean(busySlug)}
              sx={{
                justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none', px: 1.5, py: 1.25,
                borderRadius: '10px', border: '1px solid #E2E8F0', color: '#0F172A', bgcolor: '#FFFFFF',
                '&:hover': { borderColor: '#2F7D90', bgcolor: '#F5FAFC' },
              }}
            >
              <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: '#EEF7F9', color: '#2F7D90', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, flexShrink: 0 }}>
                <BusinessRoundedIcon fontSize="small" />
              </Box>
              <Typography sx={{ flex: 1, fontWeight: 600, fontSize: 15 }}>{co.name || co.slug}</Typography>
              {busySlug === co.slug
                ? <CircularProgress size={18} sx={{ color: '#2F7D90' }} />
                : <ChevronRightRoundedIcon sx={{ color: '#94A3B8' }} />}
            </Button>
          ))}
        </Stack>
        <Button fullWidth onClick={onClose} disabled={Boolean(busySlug)} sx={{ mt: 1.5, textTransform: 'none', color: '#64748B' }}>Anulo</Button>
      </DialogContent>
    </Dialog>
  );
}
